module.exports = __webpack_public_path__ + "static/media/docker.00bf46ce.svg";